module.exports = __webpack_public_path__ + "img/icon-sb-shop-more-mob.c7ce81f.svg";